<template>
  <card class="card" title="Dados do Motorista">
    <div>
      <form v-if="driver">
        <div class="row">
          <div class="col-md-5">
            <fg-input
              type="text"
              label="Nome Completo"
              placeholder="Digite seu nome..."
              v-model="driver.name"
              readonly
            ></fg-input>
          </div>
          <div class="col-md-3">
            <fg-input type="text" label="CPF" placeholder="Digite seu CPF..." v-model="driver.taxId" readonly></fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="text" label="RG" placeholder="Digite seu RG..." v-model="driver.nationalId" readonly></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="date"
              label="Admissão"
              placeholder="Digite sua admissão..."
              v-model="driver.admissionAt.split('T')[0]"
              readonly
            ></fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Função"
              placeholder="Digite sua função..."
              v-model="driver.role"
              readonly
            ></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input type="text" label="CNH" placeholder="Digite sua CNH..." v-model="driver.drivingLicense" readonly></fg-input>
          </div>
          <div class="col-md-4">
            <fg-input
              type="text"
              label="Categoria"
              placeholder="Digite sua Categoria..."
              v-model="driver.drivingLicenseCategory"
              readonly
            ></fg-input>
          </div>
          <div class="col-md-4">
            <fg-input
              type="date"
              label="Validade"
              placeholder="Digite a validade da CNH..."
              v-model="driver.drivingLicenseExpirationDate.split('T')[0]"
              readonly
            ></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Selecione a empresa</label>
              <select class="form-control input i-width" v-model="driver.company" readonly>
                <option value="28">Global</option>
                <option value="29">Fiber</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <fg-input
              type="text"
              label="CTPS"
              placeholder="Digite sua CTPS..."
              v-model="driver.ctps"
              readonly
            ></fg-input>
          </div>
          <div class="col-md-4">
            <fg-input
              type="number"
              label="Série"
              placeholder="Digite sua série..."
              v-model="driver.serie"
              readonly
            ></fg-input>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data () {
    return {
      driver: null,
    }
  },
  methods: {
    ...mapActions(["fetchDriver"]),
  },
  async mounted() {
    try {
      this.driver = await this.fetchDriver({ id: this.$route.params.id });
    } catch (err) {
      Swal.fire("Ops!", "Não foi possível carregar os motoristas", "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }
}
</style>